<template>
  <b-card class="p-0 round-card-corners" body-class="small-card-body-p">
    <slot name="info-top-corner" ></slot>
    <b-card-body class="small-card-body-p">
      <b-container>
        <b-row>
          <b-col
            sm="4" 
            cols="12"
            class="text-center my-auto col-xxl-3 padding-removal inline-mobile smallen-font"
          >
            <div class="body-img">
<!--              <lottie-animation
                :path="'./json/' + image"
                :loop="true"
                :autoPlay="true"
                :loopDelayMin="4000"
                :loopDelayMax="20000"
                @AnimControl="setAnimController"
                @mouseenter="hover()"
                :speed="1"
              />-->
              <slot name="svg-icon"></slot>
            </div>
            <p class="card-text-img text-bold"
            style="font-size: 16px; margin-top: 1em">
              {{ text }}
            </p>
          </b-col>
          <b-col sm="8" cols="12" class="col-xxl-9 padding-removal smallest-font">
            <slot name="internal-values"></slot>
          </b-col>
        </b-row>
        <slot name="additional-row"></slot>
      </b-container>
    </b-card-body>
  </b-card>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
export default {
  components: {
    LottieAnimation,
  },
  data() {
    return {
      play: false,
    };
  },
  props: {
    image: "",
    text: "",
  },
  methods: {
    hover() {
      
    },
    setAnimController(e) {
    
      e.isPaused = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-left {
  text-align: center;
  height: 4em;
}
.body-img {
  height: 6em;
  display: flex;
  align-items: center;
  justify-items: center;
}

.body-img svg {
  height: 100%;
  width: auto;
  margin-right: auto;
  margin-left: auto;
}
.card-text-img {
  font-weight: 500;
  font-size: 20px;
}
@media only screen and (min-width: 1200px) {
  
  @media only screen and (max-width:1590px) {
   .inline-mobile{
      padding-left: 0px;
      padding-right: 0px;
   }
  }

}
</style>